import { render, staticRenderFns } from "./monthlyPlafon.vue?vue&type=template&id=3c2bb2a1&"
import script from "./monthlyPlafon.vue?vue&type=script&lang=js&"
export * from "./monthlyPlafon.vue?vue&type=script&lang=js&"
import style0 from "./monthlyPlafon.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports